import {
    Box,
    Container,
    Grid,
    GridItem,
    Heading,
    Spinner,
    Text,
    useToast
} from '@chakra-ui/react'
import { ModalBuild } from 'components/molecules'
import { ModalBuildHandle } from 'components/molecules/ModalBuild/interfaces'
import { optionsDefault } from 'components/molecules/SelectBuild/constants'
import { dismountUpdateContract } from 'pages/Contract/utils/dismountUpdateContract'
import { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import ContractService from 'services/contracts'
import formatter from 'utils/formatter'
import { ValidateRecaptcha } from './ValidateRecaptcha'

export function ViewContractQrCode() {
    const location = useLocation()
    const [showRecaptcha, setShowRepactha] = useState(true)
    const [formattedContract, setFormattedContract] = useState<any>()
    const [validContract, setValidContract] = useState<boolean>(true)
    const [loading, setLoading] = useState(false)
    const toast = useToast()
    const fetchContract = async () => {
        setLoading(true)
        try {
            const searchParams = new URLSearchParams(location.search)
            const id = searchParams.get('guid') || ' '
            const hashVersao = searchParams.get('hash') || ' '
            const response = await ContractService.getContractByQRCode({
                hashVersao,
                id
            })
            const formatDataContract = dismountUpdateContract(
                response.data.contrato
            )
            setFormattedContract(formatDataContract)
            setValidContract(response.data.valido)
        } catch (error) {
            toast({
                title: `Falha ao Carregar Contrato`,
                description: 'Tente novamente mais tarde!',
                position: 'bottom-left',
                status: 'error',
                isClosable: true
            })
        } finally {
            setLoading(false)
        }
    }

    const refModalStatus = useRef<ModalBuildHandle>(null)

    const handleOpenModal = () => {
        refModalStatus.current?.onOpen()
    }

    const handleCancel = () => {
        refModalStatus.current?.onClose()
    }

    const verifyStatus = () => {
        if (!validContract) {
            handleOpenModal()
        }
    }

    useEffect(() => {
        if (!showRecaptcha) {
            fetchContract()
            verifyStatus()
        }
    }, [showRecaptcha])

    function formatarSimNao(valor: number | null | undefined) {
        return valor === 1 ? 'Sim' : 'Não';
    }

    function formatarEspecieVeiculo(valor: number | null | undefined) {
        const especie = optionsDefault.especieVeiculo.find(item => item.value === valor);
        return especie ? especie.text : 'Não Informado';
    }

    function formatarDocumento(valor: string | null | undefined) {
        const documento = valor === undefined || valor === null ? '': valor;
        if(documento?.length === 14)
            return formatter.cnpj(documento);
        else if (documento?.length === 11) 
            return formatter.cpf(documento);
        else 
            return documento;
    }

    function formatarCep(valor: string | null | undefined) {
        const cep = valor === undefined || valor === null ? '': valor;
        return formatter.cep(cep); 
    }

    function formatarTelefone(valor: string | null | undefined) {
        const fone = valor === undefined || valor === null? '': valor;
        if(fone.length === 10)
            return formatter.telefone(fone)
        else if(fone.length === 11) 
            return formatter.celular(fone)
        else 
            return fone; 
    }

    return (
        <Container
            maxW={{
                base: '100%',
                sm: '100%',
                md: 'container.md',
                lg: 'container.lg',
                xl: 'container.xl'
            }}
        >
            {loading && (
                <Box height="100vh">
                    <Spinner
                        color="primary.500"
                        size="xl"
                        position="relative"
                        left="calc(50% - 17px)"
                        top="calc(50% - 270px)"
                        speed="1s"
                    />
                </Box>
            )}
            <>
                {showRecaptcha ? (
                    <ValidateRecaptcha setShowRepactha={setShowRepactha} />
                ) : (
                    <>
                        <Heading my="4">Visualizar Contrato</Heading>
                        <Text>
                            Tenha acesso a todas informações do seu contrato
                        </Text>
                        <Box>
                            <Grid templateColumns="repeat(1fr)" gap={4}>
                                <GridItem w="100%" h="100%">
                                    <Box p="4" borderRadius="lg" height="100%">
                                        <Heading size="md" mb="2">
                                            Dados do veiculo
                                        </Heading>
                                        <Text>
                                            Chassi:{' '}
                                            {
                                                formattedContract?.vehicles
                                                    ?.chassi
                                            }
                                        </Text>
                                        <Text>
                                            Renavam:{' '}
                                            {
                                                formattedContract?.vehicles
                                                    ?.renavam
                                            }
                                        </Text>
                                        <Text>
                                            UF Gravame:{' '}
                                            {
                                                formattedContract?.vehicles
                                                    ?.ufGravame
                                            }
                                        </Text>
                                        <Text>
                                            UF Placa:{' '}
                                            {formattedContract?.vehicles?.uf}
                                        </Text>
                                        <Text>
                                            Placa:{' '}
                                            {formattedContract?.vehicles?.placa}
                                        </Text>
                                        <Text>
                                            Ano fabricação:{' '}
                                            {
                                                formattedContract?.vehicles
                                                    ?.anoFabricacao
                                            }
                                        </Text>
                                        <Text>
                                            Ano modelo:{' '}
                                            {
                                                formattedContract?.vehicles
                                                    ?.anoModelo
                                            }
                                        </Text>
                                        <Text>
                                            Remarcado:{' '}
                                            {
                                                formatarSimNao(formattedContract?.vehicles
                                                    ?.identificacaoRemarcacao)
                                            }
                                        </Text>
                                        <Text>
                                            Especie do Veiculo:{' '}
                                            {
                                                formatarEspecieVeiculo(formattedContract?.vehicles?.especie)                                                                                                
                                            }
                                        </Text>
                                    </Box>
                                </GridItem>
                                <GridItem w="100%" h="100%">
                                    <Box p="4" borderRadius="lg" height="100%">
                                        <Heading size="md" mb="2">
                                            Contrato
                                        </Heading>
                                        <Text>
                                            Data Contrato:{' '}
                                            {
                                                formatter.data(formattedContract?.contract.dataContrato)
                                            }
                                        </Text>
                                        <Text>
                                            Número do Contrato:{' '}
                                            {
                                                formattedContract?.contract
                                                    .numeroContrato
                                            }
                                        </Text>
                                        <Text>
                                            Número do Registro do Contrato:{' '}
                                            {
                                                formattedContract?.contract
                                                    .numeroRegistroContrato
                                            }
                                        </Text>
                                        <Text>
                                            Número do Gravame:{' '}
                                            {
                                                formattedContract?.contract
                                                    .numeroGravame
                                            }
                                        </Text>
                                        <Text>
                                            Quantidade de Meses:{' '}
                                            {
                                                formattedContract?.contract
                                                    .quantidadeMeses
                                            }
                                        </Text>
                                        <Text>
                                            Tipo de Restrição:{' '}
                                            {
                                                formattedContract?.contract
                                                    .tipoRestricao
                                            }
                                        </Text>
                                        <Text>
                                            Data do Aditivo:{' '}
                                            {
                                                formattedContract?.contract
                                                    .dataAditivo
                                            }
                                        </Text>
                                        <Text>
                                            Número do Aditivo do Contrato:{' '}
                                            {
                                                formattedContract?.contract
                                                    .numAditivoContrato
                                            }
                                        </Text>
                                        <Text>
                                            Data de Alteração:{' '}
                                            {
                                                formattedContract?.contract
                                                    .dataAlteracao
                                            }
                                        </Text>
                                        <Text>
                                            Status:{' '}
                                            {formattedContract?.contract.status}
                                        </Text>
                                        <Text>
                                            UF:{' '}
                                            {
                                                formattedContract?.contract
                                                    .ufContrato
                                            }
                                        </Text>
                                        <Text>
                                            Município:{' '}
                                            {
                                                formattedContract?.contract
                                                    .municipioContrato
                                            }
                                        </Text>
                                    </Box>
                                </GridItem>
                                <GridItem w="100%">
                                    <Box p="4" borderRadius="lg" height="100%">
                                        <Heading size="md" mb="2">
                                            Complementar
                                        </Heading>
                                        <Text>
                                            Taxa Mora:{' '}
                                            {
                                                formattedContract?.complementary
                                                    .identificadorTaxaMora
                                            }
                                        </Text>
                                        <Text>
                                            Taxa Multa:{' '}
                                            {
                                                formattedContract?.complementary
                                                    .identificadorTaxaMulta
                                            }
                                        </Text>
                                        <Text>
                                            Índices:{' '}
                                            {
                                                formattedContract?.complementary
                                                    .indices
                                            }
                                        </Text>
                                        <Text>
                                            Identificador Comissão:{' '}
                                            {
                                                formattedContract?.complementary
                                                    .identificadorComissao
                                            }
                                        </Text>
                                        <Text>
                                            Indicação Penalidade:{' '}
                                            {
                                                formattedContract?.complementary
                                                    .indicacaoPenalidade
                                            }
                                        </Text>
                                        <Text>
                                            Principal Recebedor Pagamento:{' '}
                                            {
                                                formatarDocumento(formattedContract?.complementary.principalRecebedorPagamento)
                                            }
                                        </Text>
                                        <Text>
                                            Tipo Documento Recebedor:{' '}
                                            {
                                                formattedContract?.complementary
                                                    .tipoDocumentoRecebedor
                                            }
                                        </Text>
                                        <Text>
                                            Documento Principal Recebedor
                                            Pagamento:{' '}
                                            {
                                                formatarDocumento(formattedContract?.complementary.documentoPrincipalRecebedorPagamento)
                                            }
                                        </Text>
                                        <Text>
                                            Tipo Documento Vendedor:{' '}
                                            {
                                                formattedContract?.complementary
                                                    .tipoDocumentoVendedor
                                            }
                                        </Text>
                                        <Text>
                                            Documento Vendedor:{' '}
                                            {
                                                formatarDocumento(formattedContract?.complementary.documentoVendedor)
                                            }
                                        </Text>
                                        <Text>
                                            Correção momenetária:{' '}
                                            {
                                                formattedContract?.complementary
                                                    .correcaoMonetaria
                                            }
                                        </Text>
                                    </Box>
                                </GridItem>
                                <GridItem w="100%">
                                    <Box p="4" borderRadius="lg" height="100%">
                                        <Heading size="md" mb="2">
                                            Financiamento
                                        </Heading>
                                        <Text>
                                            Valor Total da Dívida:{' '}
                                            {
                                                formattedContract?.financing
                                                    .valorTotalDivida
                                            }
                                        </Text>
                                        <Text>
                                            Valor da Parcela:{' '}
                                            {
                                                formattedContract?.financing
                                                    .valorParcela
                                            }
                                        </Text>
                                        <Text>
                                            Data Liberação de Crédito:{' '}
                                            {
                                                formatter.data(formattedContract?.financing.dataLiberacaoCredito)
                                            }
                                        </Text>
                                        <Text>
                                            UF Liberação de Crédito:{' '}
                                            {
                                                formattedContract?.financing
                                                    .ufLiberacaoCredito
                                            }
                                        </Text>
                                        <Text>
                                            Município Liberação de Crédito:{' '}
                                            {
                                                formattedContract?.financing
                                                    .municipioLiberacaoCredito
                                            }
                                        </Text>
                                        <Text>
                                            Vencimento da Primeira Parcela:{' '}
                                            {
                                                formatter.data(formattedContract?.financing.vencimentoPrimeiraParcela)
                                            }
                                        </Text>
                                        <Text>
                                            Vencimento da Última Parcela:{' '}
                                            {
                                                formatter.data(formattedContract?.financing.vencimentoUltimaParcela)
                                            }
                                        </Text>
                                    </Box>
                                </GridItem>
                                <GridItem w="100%">
                                    <Box p="4" borderRadius="lg" height="100%">
                                        <Heading size="md" mb="2">
                                            Consórcio
                                        </Heading>
                                        <Text>
                                            Cota do Consórcio:{' '}
                                            {
                                                formattedContract?.consortium
                                                    .cotaConsorcio
                                            }
                                        </Text>
                                        <Text>
                                            Número do Grupo:{' '}
                                            {
                                                formattedContract?.consortium
                                                    .numeroGrupo
                                            }
                                        </Text>
                                    </Box>
                                </GridItem>
                                <GridItem w="100%">
                                    <Box p="4" borderRadius="lg" height="100%">
                                        <Heading size="md" mb="2">
                                            Credor
                                        </Heading>
                                        <Text>
                                            Nome do Credor:{' '}
                                            {formattedContract?.creditor.nome}
                                        </Text>
                                        <Text>
                                            CNPJ do Credor:{' '}
                                            {
                                                formatarDocumento(formattedContract?.creditor.cnpj)
                                            }
                                        </Text>
                                        <Text>
                                            Email:{' '}
                                            {formattedContract?.creditor.email}
                                        </Text>
                                        <Text>Endereço:</Text>
                                        <Box pl="4">
                                            <Text>
                                                CEP:{' '}
                                                {
                                                    formatarCep(formattedContract?.creditor.endereco.cep)
                                                }
                                            </Text>
                                            <Text>
                                                UF:{' '}
                                                {
                                                    formattedContract?.creditor
                                                        .endereco.uf
                                                }
                                            </Text>
                                            <Text>
                                                Município:{' '}
                                                {
                                                    formattedContract?.creditor
                                                        .endereco.municipio
                                                }
                                            </Text>
                                            <Text>
                                                Logradouro:{' '}
                                                {
                                                    formattedContract?.creditor
                                                        .endereco.logradouro
                                                }
                                            </Text>
                                            <Text>
                                                Bairro:{' '}
                                                {
                                                    formattedContract?.creditor
                                                        .endereco.bairro
                                                }
                                            </Text>
                                            <Text>
                                                Número:{' '}
                                                {
                                                    formattedContract?.creditor
                                                        .endereco.numero
                                                }
                                            </Text>
                                        </Box>
                                    </Box>
                                </GridItem>
                                <GridItem w="100%">
                                    <Box p="4" borderRadius="lg" height="100%">
                                        <Heading size="md" mb="2">
                                            Devedor
                                        </Heading>
                                        <Text>
                                            Nome do Devedor:{' '}
                                            {formattedContract?.debtor.nome}
                                        </Text>
                                        <Text>
                                            Email:{' '}
                                            {formattedContract?.debtor.email}
                                        </Text>
                                        <Text>
                                            Tipo de Documento:{' '}
                                            {
                                                formattedContract?.debtor
                                                    .tipoDocumento
                                            }
                                        </Text>
                                        <Text>
                                            Número do Documento:{' '}
                                            {
                                                formatarDocumento(formattedContract?.debtor.documento)
                                            }
                                        </Text>
                                        <Text>Endereço:</Text>
                                        <Box pl="4">
                                            <Text>
                                                CEP:{' '}
                                                {
                                                    formatarCep(formattedContract?.debtor.endereco.cep)
                                                }
                                            </Text>
                                            <Text>
                                                Logradouro:{' '}
                                                {
                                                    formattedContract?.debtor
                                                        .endereco.logradouro
                                                }
                                            </Text>
                                            <Text>
                                                Bairro:{' '}
                                                {
                                                    formattedContract?.debtor
                                                        .endereco.bairro
                                                }
                                            </Text>
                                            <Text>
                                                Complemento:{' '}
                                                {
                                                    formattedContract?.debtor
                                                        .endereco.complemento
                                                }
                                            </Text>
                                            <Text>
                                                Município:{' '}
                                                {
                                                    formattedContract?.debtor
                                                        .endereco.municipio
                                                }
                                            </Text>
                                            <Text>
                                                UF:{' '}
                                                {
                                                    formattedContract?.debtor
                                                        .endereco.uf
                                                }
                                            </Text>
                                            <Text>
                                                Número:{' '}
                                                {
                                                    formattedContract?.debtor
                                                        .endereco.numero
                                                }
                                            </Text>
                                            <Text>
                                                Código do Município:{' '}
                                                {
                                                    formattedContract?.debtor
                                                        .endereco
                                                        .codigoMunicipio
                                                }
                                            </Text>
                                        </Box>
                                        <Text>
                                            Telefone:{' '}
                                            {
                                                formatarTelefone(formattedContract?.debtor.telefone)
                                            }
                                        </Text>
                                    </Box>
                                </GridItem>
                                {formattedContract?.anexos?.length && (
                                    <GridItem w="100%">
                                        <Box
                                            p="4"
                                            borderRadius="lg"
                                            height="100%"
                                        >
                                            <Heading size="md" mb="2">
                                                Anexos
                                            </Heading>
                                            {formattedContract?.anexos?.map(
                                                (anexo: any) => (
                                                    <Box key={anexo.id} mb="4">
                                                        <Text>
                                                            Nome: {anexo.nome}
                                                        </Text>
                                                        <Text>
                                                            Tipo: {anexo.tipo}
                                                        </Text>
                                                        <Text>
                                                            Tamanho:{' '}
                                                            {anexo.tamanho}
                                                        </Text>
                                                        <Text>
                                                            URL: {anexo.url}
                                                        </Text>
                                                    </Box>
                                                )
                                            )}
                                        </Box>
                                    </GridItem>
                                )}
                            </Grid>
                        </Box>
                    </>
                )}
            </>
            <ModalBuild
                ref={refModalStatus}
                onCancel={() => handleCancel}
                title="Contrato desatualizado"
            >
                <Box px="6" mt="2">
                    Para acessar os seus dados mais recentes, por favor, visite
                    a nossa plataforma e gere uma nova versão do contrato.
                </Box>
            </ModalBuild>
        </Container>
    )
}
